if (!customElements.get('dcoded-cart-promo')) {
  class DcodedCartPromo extends HTMLElement {
    static _delegationBound = false;

    static _initDelegation() {
        if (DcodedCartPromo._delegationBound) return;
        DcodedCartPromo._delegationBound = true;

        document.addEventListener('click', (e) => {
          var target = e.target;
          if (!(target instanceof Element)) return;
          if (!target.closest('.cart-drawer__dialog')) return;

          if (target.closest('[data-promo-close]')) {
            e.preventDefault();
            e.stopPropagation();
            DcodedCartPromo._closeAnyOpenSheet();
            return;
          }

          if (target.closest('[data-promo-overlay].dcoded-promo__overlay--visible')) {
            e.preventDefault();
            e.stopPropagation();
            DcodedCartPromo._closeAnyOpenSheet();
          }
        }, true);
      }

      static _closeAnyOpenSheet() {
        document.querySelectorAll('[data-promo-sheet]').forEach((sheet) => {
          sheet.classList.remove('dcoded-promo__sheet--open');
          sheet.setAttribute('aria-hidden', 'true');
        });
        document.querySelectorAll('[data-promo-overlay]').forEach((overlay) => {
          overlay.classList.remove('dcoded-promo__overlay--visible');
          overlay.setAttribute('aria-hidden', 'true');
        });
        document.querySelector('.cart-drawer__dialog')?.removeAttribute('data-promo-open');
      }

      static _isDrawerEmpty(drawer) {
        if (!(drawer instanceof Element)) return true;

        if (drawer.querySelector('.cart-drawer__footer')) {
          return false;
        }

        var countEl = drawer.querySelector('[ref="cartItemCount"]');
        var itemCount = countEl ? parseInt(countEl.textContent || '0', 10) : null;

        if (itemCount !== null && itemCount > 0) {
          return false;
        }

        return drawer.classList.contains('cart-drawer--empty') || !drawer.querySelector('.cart-drawer__footer');
      }

      static _syncDrawerEmptyState(drawer) {
        if (!(drawer instanceof Element)) return;
        drawer.classList.toggle('cart-drawer--empty', DcodedCartPromo._isDrawerEmpty(drawer));
      }

      static _clearPromoPortal(drawer) {
        if (!(drawer instanceof Element)) return;
        DcodedCartPromo._closeAnyOpenSheet();

        var promo = drawer.querySelector('dcoded-cart-promo');
        if (promo && typeof promo._restorePortalNodesToComponent === 'function') {
          promo._restorePortalNodesToComponent();
          promo._portalReady = false;
          return;
        }

        drawer.querySelector('[data-promo-portal]')?.replaceChildren();
      }

      connectedCallback() {
        DcodedCartPromo._initDelegation();

        this._sectionId = this.dataset.sectionId || '';
        this._portalReady = false;
        this._onCartChange = this._onCartChange.bind(this);
        this._onForceClose = this._onForceClose.bind(this);
        this._cacheNodes();
        this._closeSheet();
        this._bindEvents();
        requestAnimationFrame(() => this._ensurePortalNodes());

        document.addEventListener('cart:update', this._onCartChange);
        document.addEventListener('dcoded-cart-drawer-refreshed', this._onCartChange);
        document.addEventListener('dcoded-cart-promo-force-close', this._onForceClose);

        var drawer = this.closest('cart-drawer-component');
        if (drawer && !drawer.hasAttribute('data-promo-events-bound')) {
          drawer.setAttribute('data-promo-events-bound', 'true');
          drawer.addEventListener('dialog:close', () => {
            DcodedCartPromo._closeAnyOpenSheet();
          });
          drawer.addEventListener('dialog:open', () => {
            var dialog = drawer.querySelector('.cart-drawer__dialog');
            if (!dialog) return;

            DcodedCartPromo._syncDrawerEmptyState(dialog);

            if (DcodedCartPromo._isDrawerEmpty(dialog)) {
              DcodedCartPromo._clearPromoPortal(dialog);
              return;
            }

            DcodedCartPromo._withPromo(drawer, (promo) => {
              promo._ensurePortalNodes();
              promo._closeSheet();
            });
          });
        }

        var confettiWrap = this.querySelector('[data-promo-confetti]');
        if (this.dataset.appliedCode && confettiWrap) {
          this._burstConfetti(confettiWrap);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this._onCartChange);
        document.removeEventListener('dcoded-cart-drawer-refreshed', this._onCartChange);
        document.removeEventListener('dcoded-cart-promo-force-close', this._onForceClose);
        this._abortController?.abort();
        this._abortController = null;

        DcodedCartPromo._closeAnyOpenSheet();
        this._restorePortalNodesToComponent();

        this._overlay = null;
        this._sheet = null;
        this._portalReady = false;
      }

      _onCartChange(event) {
        if (!this.isConnected || !this.closest('cart-drawer-component')) return;

        var drawerRoot = this._getDrawerRoot();
        var eventItemCount = event?.detail?.data?.itemCount;

        if (typeof eventItemCount === 'number' && eventItemCount > 0) {
          drawerRoot?.classList.remove('cart-drawer--empty');
        }

        DcodedCartPromo._syncDrawerEmptyState(drawerRoot);

        if (DcodedCartPromo._isDrawerEmpty(drawerRoot)) {
          DcodedCartPromo._clearPromoPortal(drawerRoot);
          this._portalReady = false;
          return;
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => this._reinitializeAfterCartChange());
        });
      }

      _restorePortalNodesToComponent() {
        var overlay = this._overlay || this.querySelector('[data-promo-overlay]');
        var sheet = this._sheet || this.querySelector('[data-promo-sheet]');

        if (overlay && overlay.parentElement !== this) {
          this.appendChild(overlay);
          this._overlay = overlay;
        }

        if (sheet && sheet.parentElement !== this) {
          this.appendChild(sheet);
          this._sheet = sheet;
        }
      }

      _onForceClose() {
        var drawerRoot = this._getDrawerRoot();
        DcodedCartPromo._clearPromoPortal(drawerRoot);
        this._restorePortalNodesToComponent();
        this._portalReady = false;
      }

      _reinitializeAfterCartChange() {
        if (!this.isConnected) return;

        var drawerRoot = this._getDrawerRoot();
        DcodedCartPromo._syncDrawerEmptyState(drawerRoot);

        if (DcodedCartPromo._isDrawerEmpty(drawerRoot)) {
          DcodedCartPromo._clearPromoPortal(drawerRoot);
          this._portalReady = false;
          return;
        }

        DcodedCartPromo._closeAnyOpenSheet();

        this._portalReady = false;
        this._overlay = null;
        this._sheet = null;
        this._restorePortalNodesToComponent();
        this._cacheNodes();
        this._ensurePortalNodes();
        this._bindEvents();
      }

      _cacheNodes() {
        var portalRoot = this._getPortalRoot();
        var portaledOverlay = portalRoot?.querySelector('[data-promo-overlay]');
        var portaledSheet = portalRoot?.querySelector('[data-promo-sheet]');
        var localOverlay = this.querySelector('[data-promo-overlay]');
        var localSheet = this.querySelector('[data-promo-sheet]');

        if (portaledOverlay) {
          if (localOverlay && localOverlay !== portaledOverlay) localOverlay.remove();
          this._overlay = portaledOverlay;
        } else if (localOverlay) {
          this._overlay = localOverlay;
        } else {
          this._overlay = null;
        }

        if (portaledSheet) {
          if (localSheet && localSheet !== portaledSheet) localSheet.remove();
          this._sheet = portaledSheet;
        } else if (localSheet) {
          this._sheet = localSheet;
        } else {
          this._sheet = null;
        }
      }

      _bindEvents() {
        this._abortController?.abort();
        this._abortController = new AbortController();
        var signal = this._abortController.signal;

        this.addEventListener('click', (e) => {
          var target = e.target;
          if (!(target instanceof Element)) return;

          if (target.closest('[data-promo-remove]')) {
            e.preventDefault();
            e.stopPropagation();
            this._removeCode();
            return;
          }
          if (target.closest('[data-promo-change]')) {
            e.preventDefault();
            e.stopPropagation();
            this._openSheet();
            return;
          }
          if (target.closest('[data-promo-trigger]')) {
            e.preventDefault();
            e.stopPropagation();
            this._openSheet();
          }
        }, { signal });

        this._cacheNodes();
        if (!this._overlay || !this._sheet) return;

        this._overlay.addEventListener('click', () => this._closeSheet(), { signal });

        this._sheet.addEventListener('click', (e) => {
          var target = e.target;
          if (!(target instanceof Element)) return;

          if (target.closest('[data-promo-close]')) {
            e.preventDefault();
            this._closeSheet();
            return;
          }
          if (target.closest('[data-tap-code]')) {
            e.preventDefault();
            this._tapToUse(target.closest('[data-tap-code]'));
          }
        }, { signal });

        this._sheet.addEventListener('submit', (e) => {
          if (e.target.closest('[data-promo-form]')) {
            e.preventDefault();
            this._applyFromInput();
          }
        }, { signal });
      }

      _getDrawerRoot() {
        return this.closest('.cart-drawer__dialog');
      }

      _getPortalRoot() {
        const drawerRoot = this._getDrawerRoot();
        if (!drawerRoot) return null;
      
        let portal = drawerRoot.querySelector('[data-promo-portal]');
      
        if (!portal) {
          portal = document.createElement('div');
          portal.setAttribute('data-promo-portal', '');
          drawerRoot.appendChild(portal);
        }
      
        return portal;
      }

      _ensurePortalNodes() {
        this._cacheNodes();

        if (!this._overlay) {
          this._overlay = this.querySelector('[data-promo-overlay]');
        }
        if (!this._sheet) {
          this._sheet = this.querySelector('[data-promo-sheet]');
        }

        if (!this._overlay || !this._sheet) return;

        var portalRoot = this._getPortalRoot();
        if (!portalRoot) return;

        portalRoot.querySelectorAll('[data-promo-overlay]').forEach((node) => {
          if (node !== this._overlay) node.remove();
        });
        portalRoot.querySelectorAll('[data-promo-sheet]').forEach((node) => {
          if (node !== this._sheet) node.remove();
        });

        if (this._overlay.parentElement !== portalRoot) {
          portalRoot.appendChild(this._overlay);
        }
        if (this._sheet.parentElement !== portalRoot) {
          portalRoot.appendChild(this._sheet);
        }

        this._overlay.style.display = '';
        this._sheet.style.display = '';
        this._portalReady = true;
      }

      _closeSheet() {
        DcodedCartPromo._closeAnyOpenSheet();
      }

      _openSheet() {
        var drawerRoot = this._getDrawerRoot();
        DcodedCartPromo._syncDrawerEmptyState(drawerRoot);

        if (DcodedCartPromo._isDrawerEmpty(drawerRoot)) {
          this._closeSheet();
          return;
        }

        this._restorePortalNodesToComponent();
        this._cacheNodes();

        if (!this._overlay) {
          this._overlay = this.querySelector('[data-promo-overlay]');
        }
        if (!this._sheet) {
          this._sheet = this.querySelector('[data-promo-sheet]');
        }

        this._ensurePortalNodes();
        if (!this._sheet || !this._overlay) return;

        var input = this._sheet.querySelector('.dcoded-promo__input');
        var error = this._sheet.querySelector('[data-promo-error]');

        if (drawerRoot) drawerRoot.setAttribute('data-promo-open', 'true');

        this._sheet.classList.add('dcoded-promo__sheet--open');
        this._overlay.classList.add('dcoded-promo__overlay--visible');
        this._sheet.setAttribute('aria-hidden', 'false');
        this._overlay.setAttribute('aria-hidden', 'false');

        if (input) {
          input.value = '';
          window.setTimeout(function() { input.focus(); }, 350);
        }
        if (error) error.textContent = '';
      }

      _tapToUse(btn) {
        const code = btn.dataset.tapCode || '';
        if (!code) return;
        btn.classList.add('dcoded-promo__tap-btn--pulse', 'dcoded-promo__tap-btn--loading');
        btn.textContent = 'APPLYING...';
        this._applyCode(code);
      }

      _applyFromInput() {
        this._cacheNodes();
        var input = this._sheet?.querySelector('.dcoded-promo__input');
        var error = this._sheet?.querySelector('[data-promo-error]');
        if (!input) return;
        const code = input.value.trim();
        if (!code) return;
        if (error) error.textContent = '';
        this._applyCode(code);
      }

      _getCartUpdateUrl() {
        if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_update_url) {
          return Theme.routes.cart_update_url;
        }
        return '/cart/update.js';
      }

      _getSectionIds() {
        const ids = [];
        document.querySelectorAll('cart-items-component').forEach((component) => {
          if (component instanceof HTMLElement && component.dataset.sectionId) {
            ids.push(component.dataset.sectionId);
          }
        });
        if (this._sectionId && !ids.includes(this._sectionId)) {
          ids.push(this._sectionId);
        }
        return ids;
      }

      async _applyCode(code) {
        this._cacheNodes();
        var error = this._sheet?.querySelector('[data-promo-error]');
        try {
          const existingCodes = this._getExistingCodes();
          if (existingCodes.map(c => c.toLowerCase()).includes(code.toLowerCase())) {
            if (error) error.textContent = 'This code is already applied.';
            this._resetTapButtons();
            return;
          }

          const allCodes = [...existingCodes, code].join(',');
          const url = this._getCartUpdateUrl();
          const sectionIds = this._getSectionIds();

          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              discount: allCodes,
              sections: sectionIds.join(','),
              sections_url: window.location.pathname
            }),
          });

          const data = await res.json();

          if (data.discount_codes && data.discount_codes.find(
            function(d) { return d.code === code && d.applicable === false; }
          )) {
            if (error) {
              error.textContent =
                'This code applies to orders of $60 or more.'
                // 'This code isn\u2019t valid for your cart. If you use Subscribe & Save, choose a code that supports subscriptions or switch to one-time purchase.';
            }
            this._resetTapButtons();
            return;
          }

          this._closeSheet();

          this.dataset.appliedCode = code;
          this._resetTapButtons();

          this._refreshCart(data);
          
        } catch (err) {
          if (error) error.textContent = 'Something went wrong. Please try again.';
          this._resetTapButtons();
        }
      }

      async _removeCode() {
        const currentCode = this.dataset.appliedCode;
        if (!currentCode) return;

        const existingCodes = this._getExistingCodes();
        const idx = existingCodes.findIndex(c => c.toLowerCase() === currentCode.toLowerCase());
        if (idx !== -1) existingCodes.splice(idx, 1);

        try {
          const url = this._getCartUpdateUrl();

          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              discount: existingCodes.join(','),
              sections: this._getSectionIds().join(','),
              sections_url: window.location.pathname
            }),
          });

          const data = await res.json();

          this.removeAttribute('data-applied-code');
          this._resetTapButtons();

          DcodedCartPromo._refreshCartSections(data);
        } catch (err) {
          console.error('Failed to remove promo code', err);
          location.reload();
        }
      }

      _getExistingCodes() {
        const pills = document.querySelectorAll('.cart-discount__pill');
        const codes = [];
        pills.forEach((p) => {
          if (p.dataset.discountCode) codes.push(p.dataset.discountCode);
        });
        if (this.dataset.appliedCode && !codes.map(c => c.toLowerCase()).includes(this.dataset.appliedCode.toLowerCase())) {
          codes.push(this.dataset.appliedCode);
        }
        return codes;
      }

      _refreshCart(data) {
        DcodedCartPromo._refreshCartSections(data);
      }

      static _refreshCartSections(data) {
        const sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach((component) => {
          if (component instanceof HTMLElement && component.dataset.sectionId) {
            sectionIds.push(component.dataset.sectionId);
          }
        });

        let updated = false;

        sectionIds.forEach((sectionId) => {
          const sectionHtml = data.sections?.[sectionId];
          if (!sectionHtml) return;

          const parser = new DOMParser();
          const doc = parser.parseFromString(sectionHtml, 'text/html');
          const component = document.querySelector(
            'cart-items-component[data-section-id="' + sectionId + '"]'
          );

          if (!component) return;

          const newFooter = doc.querySelector('.cart-drawer__footer');
          const oldFooter = component.querySelector('.cart-drawer__footer');
          if (newFooter && oldFooter) {
            oldFooter.replaceWith(newFooter);
            updated = true;
          }

          const newItems = doc.querySelector('.cart-drawer__items');
          const oldItems = component.querySelector('.cart-drawer__items');
          if (newItems && oldItems) {
            oldItems.replaceWith(newItems.cloneNode(true));
            updated = true;
          }
        });

        requestAnimationFrame(() => {
          DcodedCartPromo._withPromo(document.querySelector('cart-drawer-component'), (promo) => {
            promo._reinitializeAfterCartChange();
          });
        });

        document.dispatchEvent(new CustomEvent('dcoded-cart-drawer-refreshed'));

        if (!updated) {
          location.reload();
        }
      }

      _resetTapButtons() {
        this._cacheNodes();
      
        const appliedCode = (this.dataset.appliedCode || '').toLowerCase();
      
        this._sheet?.querySelectorAll('[data-tap-code]').forEach((btn) => {
          const btnCode = (btn.dataset.tapCode || '').toLowerCase();
      
          btn.classList.remove(
            'dcoded-promo__tap-btn--pulse',
            'dcoded-promo__tap-btn--loading',
            'dcoded-promo__tap-btn--applied'
          );
      
          if (appliedCode && btnCode === appliedCode) {
            btn.textContent = 'APPLIED';
            btn.classList.add('dcoded-promo__tap-btn--applied');
          } else {
            btn.textContent = 'TAP TO USE';
          }
        });
      }

      static _withPromo(root, callback) {
        if (!(root instanceof Element)) return;

        var run = function() {
          var promo = root.querySelector('dcoded-cart-promo');
          if (promo && typeof promo._ensurePortalNodes === 'function') {
            callback(promo);
          }
        };

        if (customElements.get('dcoded-cart-promo')) {
          run();
          return;
        }

        customElements.whenDefined('dcoded-cart-promo').then(run);
      }

      _burstConfetti(wrap) {
        const colors = ['#e91577', '#ff6fad', '#ffd1e4', '#fbd6e3', '#f7c8dd', '#ff9ec7', '#e8b9f3', '#fce4ec'];
        const shapes = ['circle', 'heart', 'rect'];

        for (let i = 0; i < 35; i++) {
          const piece = document.createElement('span');
          piece.classList.add('confetti-piece');

          const shape = shapes[Math.floor(Math.random() * shapes.length)];
          const color = colors[Math.floor(Math.random() * colors.length)];
          const left = Math.random() * 100;
          const delay = Math.random() * 0.5;
          const rotate = (Math.random() - 0.5) * 360;
          const size = 4 + Math.random() * 5;

          piece.style.left = left + '%';
          piece.style.animationDelay = delay + 's';
          piece.style.setProperty('--confetti-rotate', rotate + 'deg');

          if (shape === 'circle') {
            piece.style.width = size + 'px';
            piece.style.height = size + 'px';
            piece.style.borderRadius = '50%';
            piece.style.background = color;
          } else if (shape === 'heart') {
            piece.innerHTML = '<svg width="' + size + '" height="' + size + '" viewBox="0 0 10 10"><path d="M5 9 C3 7,0 5,0 3 A2 2,0,0,1,5 3 A2 2,0,0,1,10 3 C10 5,7 7,5 9Z" fill="' + color + '"/></svg>';
          } else {
            piece.style.width = (size * 0.6) + 'px';
            piece.style.height = size + 'px';
            piece.style.background = color;
            piece.style.borderRadius = '1px';
          }

          wrap.appendChild(piece);
        }

        setTimeout(() => {
          wrap.querySelectorAll('.confetti-piece').forEach((p) => p.remove());
        }, 2500);
      }
    }

  customElements.define('dcoded-cart-promo', DcodedCartPromo);
}
